import { PermissionsModel } from '../../../../../common/entity/permissions.model';
import { SummaryModel } from '../../../../../common/entity/summary.model';
import { WorkflowTaskSummaryModel } from '../common/workflowTaskSummary.model';


export class WorkflowTaskChildSummaryModel implements SummaryModel {
    id: number;
    child: WorkflowTaskSummaryModel;
    permissions: PermissionsModel;
}

